<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">
        Engineer Reports
      </h1>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column">
          <input-select label="Engineer" v-model="engineer" required>
            <option v-for="record in docs" :key="record._id" :value="record">{{
              record.name
            }}</option>
          </input-select>
        </div>
        <div class="column">
          <input-field
            label="From"
            type="date"
            v-model="from"
            required
          ></input-field>
        </div>
        <div class="column">
          <input-field
            label="From"
            type="date"
            v-model="to"
            required
          ></input-field>
        </div>
      </div>

      <hr />
      <div class="columns is-mobile is-gapless">
        <div class="column">
          <router-link to="/report" class="button is-borderless"
            >Cancel</router-link
          >
        </div>
        <div class="column has-text-right">
          <button class="button is-primary" @click="onContinueClicked">
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/http";
export default {
  data() {
    return {
      loading: false,
      docs: [],
      engineer: "",
      from: null,
      to: null
    };
  },
  methods: {
    onContinueClicked() {
      let component = this;
      component.$router.push({
        path: `/report/engineer/view/${component.engineer._id}`,
        query: {
          from: component.from,
          to: component.to
        }
      });
    }
  },
  mounted() {
    let component = this;
    component.loading = true;
    component.$store.commit("setNavVisible", true);
    http
      .post("/user/index", { limit: 999, role: "engineer" })
      .then(response => {
        component.docs = response.data.docs;
        if (component.docs.length > 0) {
          component.engineer = component.docs[0];
        }
      });
  }
};
</script>
